"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandPanel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PANEL_MIN_WIDTH = 800;
const ICON_OFFSET = 27;
const TRANSITION_SEC = '0.5s';
const StyledAccordion = (0, _styles.styled)(_material.Accordion)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '&&': {
      margin: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
      minWidth: PANEL_MIN_WIDTH
    },
    '&.Mui-expanded': {
      margin: 0
    },
    '&& .MuiAccordionSummary-root': {
      minHeight: theme.spacing(4),
      height: '100%',
      padding: 0,
      margin: 0
    },
    '&& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: theme.spacing(4),
      height: '100%',
      padding: 0,
      margin: 0
    },
    '&& .MuiAccordionSummary-content': {
      margin: 0
    },
    '&& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0
    },
    '&& .MuiAccordion-region': {
      margin: 0,
      padding: 0
    },
    '&& .MuiCollapse-root': {
      margin: 0,
      padding: 0
    },
    '&& .MuiCollapse-wrapper': {
      margin: 0,
      padding: 0
    },
    '&& .MuiCollapse-wrapperInner': {
      margin: 0,
      padding: 0
    }
  };
});
const StyledSummary = (0, _styles.styled)(_material.AccordionSummary)({
  padding: 0,
  display: 'block',
  position: 'relative',
  overflow: 'hidden'
});
const StyledDetails = (0, _styles.styled)(_material.AccordionDetails)({
  display: 'block',
  padding: 0
});
const StyledSummaryRow = (0, _styles.styled)(_material.TableRow, {
  shouldForwardProp: prop => prop !== 'even'
})(_ref2 => {
  let {
    theme,
    even
  } = _ref2;
  return {
    backgroundColor: even ? theme.palette.table.body.primary.main : theme.palette.table.body.secondary.main,
    height: theme.spacing(4)
  };
});
const StyledCell = (0, _styles.styled)(_material.TableCell)({
  paddingTop: 0,
  paddingBottom: 0
});
const ExpandIcon = (0, _styles.styled)(_ExpandMore.default, {
  shouldForwardProp: prop => prop !== 'open'
})(_ref3 => {
  let {
    open
  } = _ref3;
  return {
    position: 'absolute',
    transition: "transform ".concat(TRANSITION_SEC),
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
  };
});

/**
 * 展開部品
 * @prop {object} summary - サマリ情報
 * @prop {boolean} summary.expandStatus - 展開状態(true:開いた状態, false:閉じた状態)
 * @prop {string} [summary.color] - サマリ情報の背景色
 * @prop {array} summary.rowComponents - 行に表示するコンポーネント
 * @prop {number} summary.expandColumn - 展開操作できるカラム番号
 * @prop {array} summary.columns - カラム情報
 * @prop {string} summary.columns.title - カラム名
 * @prop {string|number} summary.columns.width - カラム幅(基本は固定値とし、1カラムのみautoを設定する)
 * @prop {string} [summary.columns.className] - カラムに指定するclassName
 * @prop {node} details - 詳細情報コンポーネント
 */
class ExpandPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    let left = 0;
    for (var i = 0; i < props.summary.expandColumn; i++) {
      left = left + props.summary.columns[i].width;
    }
    this.state = {
      open: props.summary.expandStatus,
      expandMoreLeft: left
    };
  }

  /**
   * 展開可能行クリック時
   */
  handleClick() {
    this.setState({
      open: !this.state.open
    });
  }
  render() {
    const {
      className,
      summary,
      details
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(StyledAccordion, {
      defaultExpanded: summary.expandStatus,
      className: className,
      square: true,
      disableGutters: true
    }, /*#__PURE__*/_react.default.createElement(StyledSummary, {
      onClick: () => this.handleClick()
    }, /*#__PURE__*/_react.default.createElement(_material.Table, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(StyledSummaryRow, {
      className: summary.color,
      even: summary.even
    }, summary.rowComponents.map((rowComponent, index) => {
      if (summary.expandColumn === index) {
        return /*#__PURE__*/_react.default.createElement(StyledCell, {
          key: index,
          width: summary.columns[index].width,
          style: {
            paddingLeft: 32 * summary.depth
          }
        }, /*#__PURE__*/_react.default.createElement(ExpandIcon, {
          open: this.state.open,
          style: {
            left: this.state.expandMoreLeft + 32 * summary.depth - ICON_OFFSET
          }
        }), rowComponent);
      } else {
        return /*#__PURE__*/_react.default.createElement(StyledCell, {
          key: index,
          width: summary.columns[index].width
        }, rowComponent);
      }
    }))))), /*#__PURE__*/_react.default.createElement(StyledDetails, null, details));
  }
}
exports.ExpandPanel = ExpandPanel;
ExpandPanel.propTypes = {
  summary: _propTypes.default.shape({
    expandStatus: _propTypes.default.bool.isRequired,
    color: _propTypes.default.string,
    rowComponents: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
    expandColumn: _propTypes.default.number.isRequired,
    columns: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      className: _propTypes.default.string
    })).isRequired,
    depth: _propTypes.default.number,
    even: _propTypes.default.bool
  }).isRequired,
  details: _propTypes.default.node.isRequired
};
var _default = exports.default = ExpandPanel;